import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { type PurchasePrice } from "../../types";

interface PurchasePriceSliceState extends PurchasePrice {
  error?: string;
  isLoading: boolean;
}

const initialState: PurchasePriceSliceState = {
  subtotalAmount: 0,
  taxAmount: 0,
  totalAmount: 0,
  packsPrices: [],
  isLoading: false,
  error: undefined,
};

const purchasePriceSlice = createSlice({
  name: "licensing/payment/purchasePrice",
  initialState,
  reducers: {
    reqPurchasePrice(state: PurchasePriceSliceState) {
      state.isLoading = true;
    },
    gotPurchasePrice(state: PurchasePriceSliceState, action: PayloadAction<PurchasePrice>) {
      state.subtotalAmount = action.payload.subtotalAmount;
      state.taxAmount = action.payload.taxAmount;
      state.totalAmount = action.payload.totalAmount;
      state.packsPrices = action.payload.packsPrices;
      state.error = undefined;
      state.isLoading = false;
    },
    errPurchasePrice(state: PurchasePriceSliceState, action: PayloadAction<string>) {
      state.error = action.payload;
      state.isLoading = false;
    },
    resetPurchasePriceError(state: PurchasePriceSliceState) {
      state.error = undefined;
    },
    resetPurchasePrice() {
      return initialState;
    },
  },
});

export const { gotPurchasePrice, errPurchasePrice, reqPurchasePrice, resetPurchasePriceError, resetPurchasePrice } =
  purchasePriceSlice.actions;

export default purchasePriceSlice.reducer;
